module.exports = __webpack_public_path__ + "img/thumbnail_CommonWarthog_m_normal.9e136447.png";